import type { IMapTilesSource } from "@ports/app"

/**
 * Tiles shipped inside the web bundle (`public/tiles/<id>.pmtiles`).
 *
 * The path is served by the web view at `/<tilesAsset>`; MapLibre's
 * pmtiles protocol fetches via standard HTTP Range requests.
 *
 * Caveat (iOS WKWebView): historically `Range` was not honoured on
 * bundled assets — see Capacitor #7664. If that surfaces on iOS with
 * Capacitor 8, swap in the `filesystem` source instead.
 */
export function useBundledTilesSource(): IMapTilesSource {
  return {
    async resolve(tilesAsset) {
      // Leading slash → resolved relative to the WebView origin.
      return `/${tilesAsset.replace(/^\//, "")}`
    },
  }
}
